import styles from "../../../styles/MobileNumberVerification.module.css";

// images
import LoginMobileNumberImg from "../../../assets/images/login-mobile-number-img.png";
import RegisterMobileNumberImg from "../../../assets/images/register-mobile-number-img.png";
import LegionLogo from "../../../assets/images/legion-logo.png";

// legion
import {
  Flex,
  Box,
  Text,
  Anchor,
  Button,
  Image,
  PinInput,
} from "@legion-ui/core";

// hooks
import { useMobileNumberVerification } from "../../../hooks/useMobileNumberVerification";

export const MobileNumberVerification = () => {
  const {
    searchParams,
    handleBackButton,
    handleChangeValue,
    handleSubmitOtp,
    otpState,
  } = useMobileNumberVerification();

  return (
    <Flex width="100%" height="100%">
      <Flex
        alignX="center"
        alignY="start"
        padding={["5rem 0", "26px 16px"]}
        width={["", "50%"]}
        className={styles.verification__form}
      >
        <Flex
          direction="column"
          style={{ maxWidth: "464px" }}
          mq={{
            padding: {
              md: "2rem 1rem",
            },
          }}
        >
          <Anchor href="/" block>
            <Image
              width="146px"
              margin="0 0 32px 0"
              src={LegionLogo}
              alt="legion logo"
            />
          </Anchor>
          <Text
            as="h3"
            size={["36px", "24px"]}
            weight="700"
            margin="0 0 12px 0"
            color="tertiary900"
          >
            Enter Verification Code
          </Text>
          <Text
            as="p"
            size={["16px", "14px"]}
            weight="400"
            margin="0 0 24px 0"
            color="tertiary500"
          >
            Please fill the field bellow with the verification code has been
            sent via{" "}
            <Text weight="700" color="tertiary500">
              {searchParams.get("method")}
            </Text>{" "}
            to{" "}
            <Text weight="700" color="tertiary500">
              {searchParams.get("phone")}
            </Text>
            . <Text color="error500">(5s Remaining)</Text>
          </Text>

          <Box style={{ marginBottom: "24px" }}>
            <PinInput
              valueLength={4}
              value={otpState.otp}
              onChange={handleChangeValue}
              status={otpState.status}
              message={otpState.errorMessage}
              classify="lg"
            />
          </Box>

          <Text
            style={{ textAlign: "center" }}
            margin="0 0 24px 0"
            color="tertiary500"
          >
            Didn't receive the code?{" "}
            <Anchor href="" weight="700" color="primary500">
              Resend OTP code
            </Anchor>
          </Text>

          <Button
            block
            center
            margin="0 0 24px 0"
            onClick={handleSubmitOtp}
            disabled={otpState.otp.length < 4}
          >
            Submit Verification
          </Button>

          <Button
            block
            center
            margin="0 0 32px 0"
            variant="soft"
            onClick={handleBackButton}
          >
            {searchParams.get("type") === "login"
              ? "Back to Sign In"
              : "Back to Sign Up"}
          </Button>

          <div style={{ textAlign: "center" }}>
            <Text as="p" color="tertiary500">
              &#9432; Have issue OTP Code or change mobile number?
            </Text>
            <Anchor
              href="/contact-us/mobile-number"
              weight="700"
              color="primary500"
            >
              Contact Us
            </Anchor>
          </div>
        </Flex>
      </Flex>

      <Flex
        alignX="end"
        className={styles.verification__image}
        width={["", "50%"]}
      >
        <Image
          width="auto"
          height="100%"
          src={
            searchParams.get("type") === "login"
              ? LoginMobileNumberImg
              : RegisterMobileNumberImg
          }
          fit="cover"
          alt="mobile number as primary key image"
        />
      </Flex>
    </Flex>
  );
};
